var common = {
  'message.error.xml2json': 'XML을 JSON으로 변환하는 중 오류가 발생했습니다. XML 형식이 올바른지 확인하세요.'
};
export { common as default };
